export default "__VITE_ASSET__5ca74b88__"